import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;


//Get all campaigns
export const getAllCampaigns = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/campaign`);
        return { success: true, data: response.data };
    } catch (error) {
        if (error.response) {
            return { success: false, error: error.response.data.error };
        }
        return { success: false, error: "Something went wrong. Please try again." };
    }
};

//Get campaign by ID
export const getCampaignByAccountId = async (AccountId) => {
    try {
        const userId = localStorage.getItem('user_id');
        const url = userId 
            ? `${API_BASE_URL}/campaign/${AccountId}?user_id=${userId}`
            : `${API_BASE_URL}/campaign/${AccountId}`;
        const response = await axios.get(url);
        return { success: true, data: response.data };
    } catch (error) {
        if (error.response) {
            return { success: false, error: error.response.data.error };
        }
        return { success: false, error: "Something went wrong. Please try again." };
    }
};
//createCampaignUser
export const createCampaignUser = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/campaign-user`, data);
        return { success: true, data: response.data };
    } catch (error) {
        if (error.response) {
            return { success: false, error: error.response.data.error };
        }
        return { success: false, error: "Something went wrong. Please try again." };
    }
};

// Get Campaign Users by Campaign ID
export const getCampaignUsers = async (userId, campaignId) => {
    // 🔥 HARD GUARD (prevents bad API call)
    if (!userId || !campaignId) {
        console.warn("🚫 Missing params:", { userId, campaignId });
        return { success: false, error: "Missing params" };
    }

    const url = `${API_BASE_URL}/campaign-user?user_id=${userId}&campaign_id=${campaignId}`;

    console.log("✅ FINAL URL:", url);

    try {
        const response = await axios.get(url);

        return { success: true, data: response.data };
    } catch (error) {
        console.error("❌ API ERROR:", error);

        if (error.response) {
            return { success: false, error: error.response.data.error };
        }

        return { success: false, error: "Something went wrong. Please try again." };
    }
};

//Create Campaign User Score
export const createCampaignUserScore = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/campaignuser-score`, data);
        return { success: true, data: response.data };
    } catch (error) {
        if (error.response) {
            return { success: false, error: error.response.data.error };
        }
        return { success: false, error: "Something went wrong. Please try again." };
    }
};

//Get Campaign User Scores (by user_id & campaign_id)
export const getCampaignUserScores = async (userId, campaignId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/campaignuser-score/${userId}/${campaignId}`
        );
        return { success: true, data: response.data };
    } catch (error) {
        if (error.response) {
            return { success: false, error: error.response.data.error };
        }
        return { success: false, error: "Something went wrong. Please try again." };
    }
};